import { useMutation } from '@tanstack/react-query';

import { useRequest, type MutationFunction } from '@frontend/api';

import type { AgentConversationListData, AgentType } from './types';

const getUseCreateConversationKey = () => ['agents', 'conversation', 'create'];

type Payload = {
  name?: string;
  modelKey?: string;
  baseSystemPrompt?: string;
};
type CreateConversationQueryParams = {
  agentType: AgentType;
  quoteId?: number;
};

export const useCreateConversation: MutationFunction<
  AgentConversationListData,
  Payload,
  [CreateConversationQueryParams]
> = (params, { requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);

  return useMutation(
    (body) =>
      request<AgentConversationListData>(`/agents/conversations`, {
        init: {
          method: 'POST',
          body: {
            agentType: params.agentType,
            ...(params.quoteId ? { quoteId: params.quoteId } : {}),
            ...body,
          },
        },
      }),
    {
      ...queryOptions,
      mutationKey: getUseCreateConversationKey(),
    },
  );
};
